import { render } from "./WalletActivity.vue?vue&type=template&id=78ae8d5a"
import script from "./WalletActivity.vue?vue&type=script&lang=js"
export * from "./WalletActivity.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/WalletActivity.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78ae8d5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78ae8d5a', __exports__)) {
    api.reload('78ae8d5a', __exports__)
  }
  
  module.hot.accept("./WalletActivity.vue?vue&type=template&id=78ae8d5a", () => {
    api.rerender('78ae8d5a', render)
  })

}


export default __exports__